<div class="row">
  <div class="col-md-6">
    <app-label
      label="Nazwa lub nazwy klasy przeznaczenia terenu (albo symbol lub symbole klasy przeznaczenia terenu):">
      {{ application?.landUseClassNames || '-' }}
    </app-label>
  </div>
  <div class="col-md-6">
    <app-label
      label="Maksymalny udział powierzchni zabudowy [%]:">
      {{ application?.maxBuildingCoverage }}
    </app-label>
  </div>
  <div class="col-md-6">
    <app-label
      label="Maksymalna wysokość zabudowy [m]:">
      {{ application?.maxBuildingHeight || '-' }}
    </app-label>
  </div>
  <div class="col-md-6">
    <app-label
      label="Minimalny udział powierzchni biologicznie czynnej [%]:">
      {{ application?.minBiologicallyActiveArea || '-' }}
    </app-label>
  </div>
</div>
